<template>
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item :label="$t('groupmanage.gname')">
        <el-input :placeholder="$t('groupmanage.placeholder')" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button>
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="街道名" prop="name"></el-table-column>
      <!-- 省市区列显示 Name -->
      <el-table-column label="省">
        <template slot-scope="{ row }">
          {{ getAreaNameByCode(row.province) }}
        </template>
      </el-table-column>
      <el-table-column label="市">
        <template slot-scope="{ row }">
          {{ getAreaNameByCode(row.city) }}
        </template>
      </el-table-column>
      <el-table-column label="区">
        <template slot-scope="{ row }">
          {{ getAreaNameByCode(row.region) }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time"></el-table-column>
      <el-table-column label="修改时间" prop="modify_time"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="240px">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onUpdate(row)" v-permision_tjtf="'edit'">编辑</el-button>
          <el-button type="text"   @click="onDelete(row)" v-permision_tjtf="'delete'">删除</el-button>
        </template>
        
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <!-- 新增or修改街道 -->
    <el-dialog :visible.sync="visible.editGroup"
      :title="isUpdate ? $t('groupmanage.editortitle') : $t('groupmanage.appendtitle')" width="1000px">
      <el-row type="flex" justify="center">
        <el-col :span="20">
          <el-form label-position="right" label-width="100px" :model="form" :rules="formRules" ref="groupForm">
            <el-form-item label="街道名" prop="name" label-width="20%">
              <el-input placeholder="请输入街道名" v-model="form.name" maxlength="30" show-word-limit />
            </el-form-item>
            <el-form-item label="省" prop="provinceCode" label-width="20%">
              <el-select v-model="form.provinceCode" placeholder="请选择省" clearable @change="handleProvinceChange">
                <el-option v-for="item in provinceOptions" :key="item.ID" :label="item.Name"
                  :value="item.Name"></el-option>
              </el-select>
              <!-- 隐藏字段，保存实际的代码 -->
              <input type="hidden" v-model="form.provinceId" />
            </el-form-item>
            <el-form-item label="市" prop="cityCode" label-width="20%">
              <el-select v-model="form.cityCode" placeholder="请先选择市" clearable :disabled="!form.provinceCode"
                @change="handleCityChange">
                <el-option v-for="item in cityOptions" :key="item.ID" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
              <!-- 隐藏字段，保存实际的代码 -->
              <input type="hidden" v-model="form.cityId" />
            </el-form-item>
            <el-form-item label="区" prop="regionCode" label-width="20%">
              <el-select v-model="form.regionCode" placeholder="请先选择区" clearable :disabled="!form.cityCode" @change="handleRegionChange">
                <el-option v-for="item in regionOptions" :key="item.ID" :label="item.Name"
                  :value="item.Name"></el-option>
              </el-select>
              <!-- 隐藏字段，保存实际的代码 -->
              <input type="hidden" v-model="form.regionId" />
            </el-form-item>
            <el-form-item label="备注" prop="remark" label-width="20%">
              <el-input placeholder="请输入备注" v-model="form.remark" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="visible.editGroup = false">{{ $t("groupmanage.cancelbtn") }}</el-button>
        <el-button type="primary" @click="onSubmit">{{ $t("groupmanage.confirmbtn") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import { getStreetPageList, modifyStreet, delStreet, addStreet, GetAllList } from "@/api/dev_archive"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  data() {
    return {
      visible: {
        editGroup: false
      },
      tableData: [],
      areaData: [], // 完整的省市区数据
      provinceOptions: [], // 省选项
      cityOptions: [],     // 市选项
      regionOptions: [],   // 区选项
      form: {
        name: "",
        provinceCode: "",  // 省名称（显示用）
        provinceId: "",    // 省ID（保存用）
        cityCode: "",      // 市名称（显示用）
        cityId: "",        // 市ID（保存用）
        regionCode: "",    // 区名称（显示用）
        regionId: "",      // 区ID（保存用）
        remark: "",
      },
      formRules: {
        name: [{ required: true, message: "请输入街道名", trigger: "blur" }],
        provinceCode: [{ required: true, message: "请选择省", trigger: "change" }],
        cityCode: [{ required: true, message: "请选择市", trigger: "change" }],
        regionCode: [{ required: true, message: "请选择区", trigger: "change" }],
      },
      filter: {
        groupName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "", // 街道id
      areaDataLoading: false, // 防止地区数据重复加载
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.loadAreaData() // 组件创建时先加载地区数据
    this.getData()
  },
  methods: {
    // 加载完整的省市区数据
    async loadAreaData() {
      if (this.areaData.length === 0 && !this.areaDataLoading) {
        this.areaDataLoading = true
        try {
          const res = await GetAllList()
          this.areaData = res.data || []
          // 初始化省选项（ParentCode 为 0 或空 的为省级）
          this.provinceOptions = this.areaData.filter(item =>
            !item.ParentCode || item.ParentCode == '0' || item.ParentCode == 0
          )
        } catch (error) {
          console.error('加载地区数据失败:', error)
          this.$message.error('加载地区数据失败')
        } finally {
          this.areaDataLoading = false
        }
      }
    },

    // 根据 Code 查找对应的 Name
    getAreaNameByCode(code) {
      if (!code) return ''
      const area = this.areaData.find(item => String(item.ID) === String(code))
      return area ? area.Name : code
    },

    // 根据 Name 查找对应的 Code
    getAreaCodeByName(name) {
      if (!name) return ''
      const area = this.areaData.find(item => String(item.Name) === String(name))
      return area ? area.ID : name
    },

    // 编辑街道
    async onUpdate(row) {
      this.visible.editGroup = true
      this.isUpdate = true
      this.gid = row.ID

      // 确保地区数据已加载
      await this.loadAreaData()

      // 获取中文名称
      const provinceName = this.getAreaNameByCode(row.province)
      const cityName = this.getAreaNameByCode(row.city)
      const regionName = this.getAreaNameByCode(row.region)

      // 设置表单：显示中文名称，同时保存数字ID
      this.form = {
        name: row.name,
        provinceCode: provinceName,  // 显示中文
        provinceId: row.province || '',  // 保存数字ID
        cityCode: cityName,          // 显示中文
        cityId: row.city || '',      // 保存数字ID
        regionCode: regionName,      // 显示中文
        regionId: row.region || '',  // 保存数字ID
        remark: row.remark || '',
      }

      // 清空市和区选项
      this.cityOptions = []
      this.regionOptions = []

      // 如果存在省份代码，加载对应的市选项
      if (row.province) {
        this.cityOptions = this.areaData.filter(item =>
          String(item.ParentCode) === String(row.province)
        )

        // 如果存在城市代码，加载对应的区选项
        if (row.city) {
          this.regionOptions = this.areaData.filter(item =>
            String(item.ParentCode) === String(row.city)
          )
        }
      }

      // 等待 DOM 更新
      this.$nextTick(() => {
        if (this.$refs.groupForm) {
          this.$refs.groupForm.clearValidate()
        }
      })
    },

    // 处理省份选择变化
    handleProvinceChange(provinceName) {
      // 先清空下级选项
      this.form.cityCode = ''
      this.form.cityId = ''
      this.form.regionCode = ''
      this.form.regionId = ''
      this.regionOptions = []

      if (provinceName) {
        // 根据选中的省份名称找到对应的ID
        const province = this.provinceOptions.find(item => item.Name === provinceName)
        if (province) {
          this.form.provinceId = province.ID

          // 加载市选项
          this.cityOptions = this.areaData.filter(item =>
            String(item.ParentCode) === String(province.ID)
          )
        }
      } else {
        this.cityOptions = []
        this.form.provinceId = ''
      }
    },

    // 处理城市选择变化
    handleCityChange(cityName) {
      this.form.regionCode = ''
      this.form.regionId = ''
      this.regionOptions = []
      console.log("kanzheli")
      if (cityName) {
        // 根据选中的城市名称找到对应的ID
        const city = this.cityOptions.find(item => item.Name === cityName)
        if (city) {
          this.form.cityId = city.ID

          // 加载区选项
          this.regionOptions = this.areaData.filter(item =>
            String(item.ParentCode) === String(city.ID)
          )
        }
      } else {
        this.regionOptions = []
        this.form.cityId = ''
      }
    },

    // 处理区选择变化
    handleRegionChange(regionName) {
      if (regionName) {
        // 根据选中的区名称找到对应的ID
        const region = this.regionOptions.find(item => item.Name === regionName)
        if (region) {
          this.form.regionId = region.ID
        }
      } else {
        this.form.regionId = ''
      }
    },

    // 删除街道
    onDelete(row) {
      this.$confirm('确定删除该街道吗？', '提示', {
        type: 'warning'
      }).then(() => {
        delStreet({ ID: row.ID }).then((res) => {
          this.$message.success(`删除成功`)
          this.toFilter()
        })
      }).catch(() => { })
    },

    // 获取表格数据
    getData() {
      this.loading = true
      getStreetPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        name: this.filter.groupName || null
      })
        .then((res) => {
          const rawData = res.data || []
          this.tableData = rawData
          this.pageParams.total = res.total || 0
        })
        .catch(err => {
          console.error('获取街道列表失败:', err)
          this.$message.error('获取数据失败')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 新增街道
    onAdd() {
      this.visible.editGroup = true
      this.isUpdate = false

      // 重置表单
      this.form = {
        name: "",
        provinceCode: "",
        provinceId: "",
        cityCode: "",
        cityId: "",
        regionCode: "",
        regionId: "",
        remark: "",
      }

      // 清空选项
      this.cityOptions = []
      this.regionOptions = []

      // 确保有地区数据
      if (this.areaData.length === 0) {
        this.loadAreaData()
      }

      // 等待 DOM 更新
      this.$nextTick(() => {
        if (this.$refs.groupForm) {
          this.$refs.groupForm.clearValidate()
        }
      })
    },

    // 提交表单
    onSubmit() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading()

          // 准备请求数据，需要从中文名称转换回代码
          // 注意：如果用户选择了新的选项，form.provinceId等已经更新
          // 如果用户没有修改，form.provinceId等仍然保存着原始的ID
          const reqData = {
            name: this.form.name,
            province: this.form.provinceId,
            city: this.form.cityId,
            region: this.form.regionId,
            remark: this.form.remark,
          }

          // 如果用户选择了新的选项，但ID没有正确设置，需要从名称转换
          if (!reqData.province && this.form.provinceCode) {
            reqData.province = this.getAreaCodeByName(this.form.provinceCode)
          }
          if (!reqData.city && this.form.cityCode) {
            reqData.city = this.getAreaCodeByName(this.form.cityCode)
          }
          if (!reqData.region && this.form.regionCode) {
            reqData.region = this.getAreaCodeByName(this.form.regionCode)
          }

          if (this.isUpdate) {
            console.log(this.form.provinceCode)
            reqData.ID = this.gid
            modifyStreet(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.modifiedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .catch(err => {
                console.error('修改街道失败:', err)
                //this.$message.error('修改失败')
              })
              .finally(() => {
                loading.close()
              })
          } else {
            addStreet(reqData)
              .then((res) => {
                this.$message.success(`${this.$t("publics.addedsuccessful")}`)
                this.visible.editGroup = false
                this.toFilter()
              })
              .catch(err => {
                console.error('新增街道失败:', err)
                //this.$message.error('新增失败')
              })
              .finally(() => {
                loading.close()
              })
          }
        }
      })
    },

    // 从 pageMixin 继承的方法
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },

    handleSizeChange(val) {
      this.pageParams.limit = val
      this.toFilter()
    },

    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.my-pagination {
  margin-top: 20px;
  text-align: right;
}

.table-header-cell {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 600;
}
</style>